import React from "react";
import "./StepperRow.css";
import Stepper from "./Stepper";

type StepperProps = React.ComponentProps<typeof Stepper>;

interface StepperRowProps extends Omit<StepperProps, 'hideLabel'> {
    /** Left-hand visual: an image element, or a line icon (wrap with iconTile). */
    icon: React.ReactNode;
    /** Show `icon` on a soft red tile, as on the settings rows. */
    iconTile?: boolean;
    summary?: React.ReactNode;
    /** Shown beside the title, e.g. a status chip. */
    badge?: React.ReactNode;
}

// A settings-list row with a compact stepper: icon · title + summary · [−] value [+].
// Used by Sanitation and Calibration; stack several inside .stepper-rows.
const StepperRow = ({ icon, iconTile, summary, badge, label, ...stepper }: StepperRowProps) => (
    <div className="stepper-row-item">
        {iconTile ? <span className="stepper-row-icon-tile">{icon}</span> : icon}
        <div className="stepper-row-text">
            <span className="stepper-row-title">{label}{badge}</span>
            {summary && <span className="stepper-row-summary">{summary}</span>}
        </div>
        <Stepper hideLabel label={label} {...stepper} />
    </div>
);

export const StepperRows = ({ children }: { children: React.ReactNode }) => (
    <div className="stepper-rows">{children}</div>
);

export default StepperRow;
